import React, { useEffect, useState } from 'react';
import { Table, Tag, Card, Descriptions } from 'antd';
import moment from 'moment';

import { MainWrapper } from '../../components/newDesign/MainWrapper/MainWrapper';
import { CaseMainTitle } from '../../components/newDesign/CaseMainTitle';
import { getUserAccessAttempts } from '../../services/api';

const UserProfile = () => {
    const [user, setUser] = useState(null);
    const [attempts, setAttempts] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const userStr = window.localStorage.getItem('user_params');
        if (!userStr) return;

        try {
            const parsed = JSON.parse(userStr);
            setUser(parsed);

            if (parsed.userId) {
                setLoading(true);
                getUserAccessAttempts(parsed.userId)
                    .then((data) => {
                        // бек отдаёт массив попыток
                        setAttempts(Array.isArray(data) ? data : []);
                    })
                    .catch((error) => {
                        console.error('Ошибка при загрузке попыток доступа', error);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        } catch (e) {
            console.error('Не удалось распарсить user_params', e);
        }
    }, []);

    const columns = [
        {
            title: 'Дата и время',
            dataIndex: 'attemptDate',
            key: 'attemptDate',
            render: (value) =>
                value ? moment(value).format('DD.MM.YYYY HH:mm:ss') : '-',

        },
        {
            title: 'IP-адрес',
            dataIndex: 'ipAddress',
            key: 'ipAddress',
        },
        {
            title: 'Система',
            dataIndex: 'system',
            key: 'system',
        },
        {
            title: 'Тип',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'Описание',
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,
        },
        {
            title: 'Статус',
            dataIndex: 'success',
            key: 'success',
            render: (success) => (
                <Tag color={success ? 'success' : 'error'}>
                    {success ? 'Успешно' : 'Ошибка'}
                </Tag>
            ),
            filters: [
                { text: 'Успешные', value: true },
                { text: 'Неуспешные', value: false },
            ],
            onFilter: (value, record) => record.success === value,
        },
    ];

    const roles =
        user?.roles?.map((r) => r.name).join(', ') || '—';

    return (
        <MainWrapper>
            <CaseMainTitle>
                Профиль пользователя {user?.username ? `«${user.username}»` : ''}
            </CaseMainTitle>

            <Card style={{ marginBottom: 24, padding:0, color: 'white',         width: '40%', }}>
                <Descriptions column={1} bordered contentStyle={{

                    color: 'white'
                }}>
                    <Descriptions.Item label="Логин" labelStyle={{
                        color: 'white'
                    }} >
                        {user?.username || '—'}
                    </Descriptions.Item>
                    <Descriptions.Item label="ID пользователя" labelStyle={{
                        color: 'white'
                    }} >
                        {user?.userId ?? '—'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Роли" labelStyle={{
                        color: 'white'
                    }} >
                        {roles}
                    </Descriptions.Item>
                    <Descriptions.Item label="Статус" labelStyle={{
                        color: 'white'
                    }} >
                        {user?.enabled ? 'Активен' : 'Заблокирован'}
                    </Descriptions.Item>
                </Descriptions>
            </Card>

            <Card title="Попытки доступа" bodyStyle={{ padding: 0 }} headStyle={{
                backgroundColor: '#19375a',
                color: 'white',
            }}>
                <Table
                    rowKey="id"
                    loading={loading}
                    dataSource={attempts}
                    columns={columns}
                    pagination={{
                        defaultPageSize: 10,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        showSizeChanger: true,
                    }}
                />
            </Card>
        </MainWrapper>
    );
};

export default UserProfile;